import {Component, Input, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {DateType} from '../../../../../statistics/enums/date-type.enum';
import {DateTimeUnitTypes} from '../../../../../statistics/enums/date-time-unit-types.enum';
import {MapSummaryApiService} from '../../../../services/map/map-summary-api/map-summary-api.service';
import {takeWhile} from 'rxjs/operators';
import {DataCacheApiService} from '../../../../services/map/data-cache-api/data-cache-api.service';
import {AgGridAngular} from 'ag-grid-angular';
import {MapService} from '../../../../services/map/map/map.service';
import dayjs from 'dayjs';

@Component({
  selector: 'map-summary-top-routes',
  templateUrl: './map-summary-top-routes.component.html',
  styleUrls: ['./map-summary-top-routes.component.less'],
  encapsulation: ViewEncapsulation.None
})
export class MapSummaryTopRoutesComponent implements OnInit {

  constructor(private mapSummaryApi: MapSummaryApiService,
              private dataCacheApiService: DataCacheApiService,
              private mapService: MapService) {
  }

  @ViewChild('agGrid', {static: false}) agGrid: AgGridAngular;
  @Input() set isActive(isActive: boolean) {
    if (isActive) {
      this.currentTabSelection = 'topRoutes';
      this.mapService.drawTestRoute(null);
      this.restoreDrawnPath();
    }
  }

  currentTabSelection: any;
  topRoutePathSelected: any;
  topRouteResult: any;
  haveResult: boolean;
  lastUpdateTime: any;
  columnDefs: any = [
    {headerName: 'Route', field: 'route', width: 170},
    {headerName: 'Hits', field: 'hits', width: 175}
  ];
  gridOptions: any = {
    defaultColDef: {
      resizable: true
    },
    rowSelection: 'single',
    suppressCellSelection: true
  };

  dataReady = false;


  ngOnInit(): void {
    this.dataCacheApiService.getDataReady().pipe(takeWhile(() => this.dataReady === false)).
    subscribe(x => {
      if (x === true) {
        this.dataReady = true;
        this.fetchTopRoutes();
      }
    });
  }

  removeSelection(): void {
    if (this.agGrid.api) {
      this.agGrid.api.deselectAll();
    }
  }

  private restoreDrawnPath(): void {
    if (this.agGrid.api) {
      if (this.topRoutePathSelected) {
      } else {
        this.selectFirstRow();
      }
    }
  }

  private preparePathForDraw(topRoutePath): any {
    const path = {nodes: [], edges: [], color: 'purple'};

    path.edges = this.prepareEdgesToDraw(topRoutePath);
    path.nodes = this.prepareNodesToDraw(topRoutePath);

    return [path];
  }

  private prepareEdgesToDraw(topRoutePath): any {
    const edges = [];

    edges.push('peerConnection_' + topRoutePath.srcPeerConnection);

    if (topRoutePath.edges !== null) {
      topRoutePath.edges.forEach((edge) => {
        edges.push('connection_' + edge.connectionId);
      });
    }

    if (topRoutePath.srcPeerConnection !== topRoutePath.destPeerConnection) {
      edges.push('peerConnection_' + topRoutePath.destPeerConnection);
    }
    return edges;
  }

  private prepareNodesToDraw(topRoutePath): any {
    const nodes = [];

    nodes.push('node_' + topRoutePath.srcNode);

    if (topRoutePath.edges !== null) {
      topRoutePath.edges.forEach((edge) => {
        nodes.push('node_' + edge.connDestNode);
      });
    }

    if (topRoutePath.destNode !== null && nodes.indexOf('node_' + topRoutePath.destNode) === -1) {
      nodes.push('node_' + topRoutePath.destNode);
    }

    return nodes;
  }

  onSelectionChanged(): any {
    const selectedPaths = this.agGrid.api.getSelectedRows();

    if (selectedPaths.length === 1) {
      this.topRoutePathSelected = selectedPaths[0];
      this.mapService.drawTestRoute(this.preparePathForDraw(this.topRoutePathSelected));
    } else {
      this.topRoutePathSelected = null;
      this.mapService.drawTestRoute(null);
    }
  }

  private fetchTopRoutes(): void {
    const successFn = (fetchedTopFive) => {
      this.lastUpdateTime = dayjs().format('HH:mm:ss');
      this.haveResult = Array.isArray(fetchedTopFive.routes) && fetchedTopFive.routes.length > 0;
      this.topRouteResult = fetchedTopFive;

      if (this.agGrid.api) {
        this.agGrid.api.setRowData(fetchedTopFive.routes);
      }
      this.selectFirstRow();
    };

    this.mapSummaryApi.getTopRoutes(successFn,
      {dateType: DateType.RELATIVE, relativeTimeUnit: DateTimeUnitTypes.HOUR, relativeTimeUnitValue: 3, maxRoutes: 5},
      this.dataCacheApiService.getPcons(), this.dataCacheApiService.getNodes());
  }

  private selectFirstRow(): void {
    if (this.currentTabSelection === 'topRoutes' && this.agGrid.api) {
      const firstRow = this.agGrid.api.getRowNode('0');

      if (firstRow) {
        firstRow.setSelected(true);
        this.topRoutePathSelected = firstRow;
      }
    }
  }
}
